import React, { useState } from 'react';
import { Box, Stepper, Step, StepLabel, Button, Typography, Paper, CircularProgress, Fade } from '@mui/material';
import Step1Upload from '../../components/staff/historical-import/Step1Upload';
import Step2PersonalInfo from '../../components/staff/historical-import/Step2PersonalInfo';
import Step3History from '../../components/staff/historical-import/Step3History';
import Step4Validation from '../../components/staff/historical-import/Step4Validation';
import Step6Review from '../../components/staff/historical-import/Step6Review';
import AppHeader from '../../components/AppHeader';

const steps = [
  'Upload & Map',
  'Personal Info',
  'Employment History',
  'Validation & Dry Run',
  'Review & Execute'
];

export default function HistoricalStaffImport({ setIsLoggedIn }) {
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  
  const [validatedData, setValidatedData] = useState(null);
  const [validationSummary, setValidationSummary] = useState(null);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleValidationSuccess = (data) => {
    setValidatedData(data.staff);
    setValidationSummary(data.summary);
    handleNext();
  };

  const handleExecutionSuccess = (result) => {
    alert(`Success! Imported ${result.message}`);
    // You could redirect to staff list here
  };

  return (
    <Fade in={true} timeout={500}>
      <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc' }}>
        <AppHeader setIsLoggedIn={setIsLoggedIn} />
        <Box sx={{ p: 4, maxWidth: 1400, mx: 'auto' }}>
          <Typography 
            variant="h4" 
            gutterBottom 
          sx={{ fontWeight: 800, letterSpacing: '-0.02em', color: '#0f172a', mb: 1 }}
        >
          Historical Staff Import
        </Typography>
        <Typography 
          variant="subtitle1" 
          gutterBottom 
          sx={{ color: '#64748b', mb: 3 }}
        >
          Migrate staff timelines and personal data securely with multi-step validation.
        </Typography>
        
        <Paper sx={{ 
          p: 3, 
          mb: 3, 
          borderRadius: 4, 
          boxShadow: '0 4px 20px 0 rgba(0,0,0,0.04)' 
        }}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Paper>

        <Paper sx={{ 
          p: 3, 
          minHeight: '400px', 
          borderRadius: 4, 
          boxShadow: '0 4px 20px 0 rgba(0,0,0,0.04)' 
        }}>
        {activeStep === 0 && (
          <Step1Upload 
            onSuccess={handleValidationSuccess} 
            loading={loading}
            setLoading={setLoading}
          />
        )}
        
        {activeStep === 1 && <Step2PersonalInfo data={validatedData} />}
        {activeStep === 2 && <Step3History data={validatedData} />}
        {activeStep === 3 && <Step4Validation data={validatedData} />}
        {activeStep === 4 && (
          <Step6Review 
            data={validatedData} 
            summary={validationSummary} 
            onComplete={handleExecutionSuccess} 
          />
        )}

        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, mt: 4 }}>
          <Button
            color="inherit"
            disabled={activeStep === 0 || loading}
            onClick={handleBack}
            sx={{ mr: 1 }}
          >
            Back
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />
          {activeStep > 0 && activeStep < steps.length - 1 && (
            <Button 
              onClick={handleNext} 
              disabled={loading}
              sx={{ bgcolor: 'primary.main', color: '#fff', '&:hover': { bgcolor: 'primary.dark' } }}
            >
              Next
            </Button>
          )}
        </Box>
        </Paper>
        </Box>
      </Box>
    </Fade>
  );
}
